<template>
  <div class="flex-1 p-4 text-sm">
    <div class="text-transparent text-xs">{{reload}}</div>
    <div class="col-span-full flex justify-end gap-3">
      <!-- 宛名の印刷と退職届の PDF は出力画面（AKBS関連「出力」。サブタスク「●●送付」から開く）で出す。ここの「宛名印刷」「退職届PDF」ボタンは外した（ユーザー決定） -->

      <!-- 人事部、管理者のみ -->
      <div class="ml-auto" v-if="auth">
        <div v-tooltip="'人事部、管理者のみ設定可能'" class="w-auto py-0 text-sm text-right mr-3 text-indigo-800 hover:text-indigo-500 cursor-pointer" @click="openChatRoomId=true">Chatwork通知設定</div>
      </div>
    </div>

    <div class="mt-3" style="min-width: 500px;">

      <div v-if="!requestPost._id" class="text-xs font-bold text-red-700 mb-3 sm:col-span-full">
        清掃員の新規入社は面接タスク完了時に自動で作られます
      </div>

      <div class="five-selection">
        <SelectionButton2
          name="employmentClass"
          caption="種別（サブタスクを作成するため）"
          v-model="requestPost.employmentClass"
          :item="classSelections"
          :multiSelect="false"
          :required="true"
          :error="!requireValidateArr('employmentClass', '種別').result"
          :errorMessage="requireValidateArr('employmentClass', '種別').message"
          :disabled="referenceMode2||!requestPost.notNewEnter"
          @change="changeEmploymentClass($event)"
        />
      </div>

      <!-- 契約変更の場合 -->
      <div class="mt-3" v-if="isShow('変更もしくは終了')">
        <div class="text-xs mb-1 font-bold text-gray-700">変更もしくは終了
          <span class="text-red-500"> * </span>
        </div>
        <!-- 改修注意！増えたら、タイトルも変わるように！ -->
        <div class="flex text-sm border border-blue-800 rounded text-center cursor-pointer w-fit" :class="referenceMode2?'cursor-not-allowed':''">
          <div @click="clickModifyType(1, false)" :class="requestPost.modifyType==1 && !requestPost.changeOnlyPrice?'bg-blue-800 text-white font-bold':'text-gray-600 bg-white'" class="rounded-l w-115px py-2 px-3 border-r">契約内容変更</div>
          <div @click="clickModifyType(1, true)" :class="requestPost.modifyType==1 && requestPost.changeOnlyPrice?'bg-blue-800 text-white font-bold':'text-gray-600 bg-white'" class="w-115px py-2 px-3 border-r">金額のみ変更</div>
          <div @click="clickModifyType(2, false)" :class="requestPost.modifyType==2?'bg-blue-800 text-white font-bold':'text-gray-600 bg-white'" class="rounded-r w-115px py-2 px-3">作業終了</div>
        </div>
      </div>

      <!-- 退職日 -->
      <WmsDateInput
        v-if="isShow('退職日')"
        name="employmentRetirementDate"
        caption="退職日"
        v-model="requestPost.employmentRetirementDate"
        :clearable="true"
        :required="isRequired('退職日')"
        :error="!requireValidateStr('employmentRetirementDate', '退職日').result"
        :errorMessage="requireValidateStr('employmentRetirementDate', '退職日').message"
        @change="setLimitDate()"
        :disabled="referenceMode2"
        class="mt-3"
      />

      <!-- 入社日 -->
      <WmsDateInput
        v-if="isShow('入社日')"
        name="employmentHireDate"
        caption="入社日"
        v-model="requestPost.employmentHireDate"
        :disabled="referenceMode2"
        :clearable="true"
        :required="isRequired('入社日')"
        :error="!requireValidateStr('employmentHireDate', '入社日').result"
        :errorMessage="requireValidateStr('employmentHireDate', '入社日').message"
        @change="setLimitDate()"
        class="mt-3"
      />

      <NumericTextInput2
        name="employmentStaffNumber"
        :caption="type=='再入社'?'新しい社員番号':'社員番号'"
        v-model="requestPost.employmentStaffNumber"
        :format="false"
        :disabled="true"
        class="mt-3"
      />

      <div v-if="type=='再入社'" class="font-bold text-gray-500 mt-1 ml-3 mb-8">
        ◆ 以前の社員番号：{{ requestPost.beforeStaffCd }}
      </div>

      <!-- 氏名 -->
      <div class="mt-3 mb-7">
        <!-- 手入力 -->
        <WmsTextInput
          v-if="requestPost.employmentClass&&['新規入社'].includes(type)"
          name="employmentName"
          caption="氏名"
          v-model="requestPost.employmentName"
          :disabled="referenceMode2"
          :required="isRequired('氏名')"
          :error="!requireValidateStr('employmentName', '氏名').result"
          :errorMessage="requireValidateStr('employmentName', '氏名').message"
          @change="setTitle()"
        />
        <!-- 選択 -->
        <WmsSuggestInput
          v-else
          name="employmentName"
          :caption="type=='再入社'?'氏名（ドロップダウンは退職者です。選択すると以前の住所などが表示されます。）':'氏名'"
          :required="isRequired('氏名')"
          :selectionItems="employmentNameList"
          displayField="nameStaff"
          v-model="requestPost.employmentName"
          :disabled="referenceMode2"
          :error="!requireValidateStr('employmentName', '氏名').result"
          :errorMessage="requireValidateStr('employmentName', '氏名').message"
          @selected="staffSelected($event)"
          @blur="staffChanged()"
        >
        </WmsSuggestInput>

        <!-- 生年月日・年齢（雇用支持から取得した生年月日） -->
        <div v-if="requestPost.birthday" class="font-bold text-gray-500 mt-1 ml-3">
          ◆ 生年月日：{{ requestPost.birthday }}
          <span class="pl-5">現在 {{ ageCalculation(requestPost.birthday) }} 歳</span>
        </div>

        <!-- 再入社：前回の退職の内容（清掃員を選んだときに AKBS の清掃員マスタから入れる。再入社NGなら赤字） -->
        <div v-if="type=='再入社' && requestPost.beforeStaffCd" class="font-bold mt-1 ml-3" :class="requestPost.beforeIsBanned ? 'text-red-700' : 'text-gray-500'">
          ◆ 前回の退職日：{{ formatDate(requestPost.beforeDateResignation) || '－' }}
          <span class="pl-5">退職理由：{{ requestPost.beforeRetireReason || '－' }}</span>
          <span class="pl-5">再入社NG：{{ requestPost.beforeIsBanned ? 'あり' : 'なし' }}</span>
        </div>
      </div>

      <!-- 遷移ボタン -->
      <div v-if="!requestPost._id" class="text-xs font-bold text-red-700 mb-1">一度保存しなければ遷移できません</div>
      <PrimaryButton class="" :buttonContents="'要'" text="雇用指示へ登録" :disabled="!requestPost._id" @click="toAkbsEmployment()">
        <Icon slot="before" iconName="ClipboardList" iconType="solid" :strokeWidth="2" class="h-5 w-5 mr-1.5" />
      </PrimaryButton>


      <InputGroupLabel
        v-if="isShow('必要な書類')"
        caption="その他"
        class="mt-10"
      />

      <SelectionButton2
        v-if="isShow('必要な書類')"
        name="employmentMaterial"
        caption="必要な書類"
        v-model="requestPost.employmentMaterial"
        :item="materialSelections"
        :multiSelect="true"
        :disabled="referenceMode"
        :required="isRequired('必要な書類')"
        :error="!requireValidateArr('employmentMaterial', '必要な書類').result"
        :errorMessage="requireValidateArr('employmentMaterial', '必要な書類').message"
        class="mt-3"
      />

      <div class="mt-3" v-if="isShow('履歴書')">
        <div class="text-xs font-bold text-gray-700 mb-1">
          添付資料（履歴書）<span v-if="isRequired('履歴書')" class="ml-1 text-red-500"> * </span>
        </div>
        <WmsAttachment
          name="employmentDocument"
          style="max-width: none!important;"
          :value="requestPost.employmentDocument"
          :disabled="referenceMode"
          @change="attachmentChange('employmentDocument', $event)"
          :errorMessage="requireValidateAttach('employmentDocument', '履歴書').message"
        />
      </div>

      <WmsTextInput
        name="employmentRemarks"
        caption="連絡事項"
        v-model="requestPost.employmentRemarks"
        :multiline="true"
        :rows="3"
        :disabled="referenceMode"
        class="mt-3"
      />
    </div>

    <!-- 退社専用Chatwork設定 -->
    <InterviewsChatRoomIdModal
      v-model="openChatRoomId"
      :open="openChatRoomId"
      :type="2"
      @close="openChatRoomId=false"
    />
  </div>
</template>

<script>
  import * as utils from '@libs/utils'
  import * as dialogs from '@libs/dialogs'
  import * as helper from '@libs/helper'
  import * as constants from '@libs/constants'
  import * as backend from '@libs/backend'
  import moment from 'moment'
  import Icon from '@components/Icon.vue'
  import PrimaryButton from '@components/PrimaryButton.vue'
  import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
  import WmsTextInput from '@wmscomponents/WmsTextInput.vue'
  import NumericTextInput2 from '@components/NumericTextInput2.vue'
  import SelectionButton2 from '@components/SelectionButton2.vue'
  import WmsAttachment from '@wmscomponents/WmsAttachment.vue'
  import InputGroupLabel from '../components/InputGroupLabel.vue'
  import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
  import InterviewsChatRoomIdModal from '../components/InterviewsChatRoomIdModal.vue'

  const CLASS_SELECTIONS = [
    {
      value: '物件追加',
      text: '物件追加'
    },
    {
      value: '契約変更',
      text: '契約変更'
    },
    {
      value: '退職',
      text: '退職'
    },
    {
      value: 'その他変更',
      text: 'その他変更'
    },
    {
      value: '再入社',
      text: '再入社'
    }
  ]

  // 新規入社 必須項目
  const ENTER = ['入社日', '氏名', '必要な書類', '履歴書']

  // 再入社 必須項目
  const AGAIN = ['入社日', '氏名', '必要な書類']

  // 物件追加 必須項目
  const ADD = ['氏名', '必要な書類']

  // 契約変更 必須項目
  const RETIRE1 = ['変更もしくは終了', '氏名']

  // 退職 必須項目
  const RETIRE2 = ['退職日', '氏名']

  // その他変更 必須
  const OTHER = ['氏名']

  export default {
    components: {
      Icon,
      PrimaryButton,
      WmsDateInput,
      WmsTextInput,
      NumericTextInput2,
      InputGroupLabel,
      SelectionButton2,
      WmsAttachment,
      WmsSuggestInput,
      InterviewsChatRoomIdModal,
    },

    props: {
      requestPost: {
        type: Object,
        default: () => {}
      },
      referenceMode: {
        type: Boolean,
        default: false
      },
      referenceMode2: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        materialSelections: constants.MATERIAL_SELECTIONS,

        reload: 0,
        loading: false,
        // 清掃員リスト
        employmentNameList: [],
        // Chatwork設定モーダルopen
        openChatRoomId: false,
        // 清掃員リストの種別
        staffListType: '',
      }
    },

    computed: {
      /**
       * Chatwork設定できる人
       * 人事もしくは管理者権限
       */
      auth() {
        // 人事部所属
        const dep = this.$store.getters.dualPosition
        if (dep && dep.length) {
          // 人事部か確認
          const isDep = dep.find((d) => {
            return (d.departmentName.indexOf('人事') > -1)
          })
          if (isDep && isDep.departmentName) {
            return true
          }
        }
        // 管理者権限の場合
        let auth2 = this.$store.getters.auth
        if (auth2 && auth2.adminAuth) {
          return true
        }
        return false
      },

      /**
       * 種別の選択項目
       */
      classSelections() {
        let res = utils.clone(CLASS_SELECTIONS)
        if (!this.requestPost.notNewEnter)  res =  [
          {
            value: '新規入社',
            text: '新規入社'
          }
        ]
        return res
      },

      /**
       * 種別
       */
      type() {
        if (this.requestPost.employmentClass[0]) {
          return this.requestPost.employmentClass[0]
        }
        return ''
      },

      /**
       * 年齢計算
       */
      ageCalculation() {
        return (val) => {
          if (val) {
            const birth = moment(val, 'YYYY-MM-DD', true)
            if (!birth.isValid()) return null
            return moment().diff(birth, 'years')
          }
        }
      },

      /**
       * 必須項目入力チェック（文字列）
       */
      requireValidateStr() {
        return (item, name)=> {
          if (this.isRequired(name)) {
            if (!this.requestPost[item] && this.requestPost[item] !== 0) {
              return {
                result: false,
                message: `${name}は必須項目です。${name}を入力してください。`
              }
            }
          }

          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 必須項目入力チェック（配列）
       */
      requireValidateArr() {
        return (item, name)=> {
          if (this.isRequired(name)) {
            if (!this.requestPost[item] || !this.requestPost[item].length) {
              return {
                result: false,
                message: `${name}は必須項目です。${name}を選択してください。`
              }
            }
          }

          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 必須項目入力チェック（添付ファイル）
       */
      requireValidateAttach() {
        return (item, name)=> {
          if (this.isRequired(name)) {
            if (!this.requestPost[item] || (!this.requestPost[item].content && !this.requestPost[item].url)) {
              return {
                result: false,
                message: `${name}は必須項目です。${name}を添付してください。`
              }
            }
          }
          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 表示するか否か
       */
      isShow() {
        return (name) => {
          // 種別
          const ec = this.requestPost.employmentClass

          if (ec && ec.length) {
            return this.isRequired(name)
          }
          return false
        }
      },

      /**
       * 種別によって必須が変わる
       * @param name 項目名
       */
      isRequired() {
        return (name) => {
          // 種別はいつでも必須
          if (name == '種別') {
            return true
          }
          // 種別
          const ec = this.requestPost.employmentClass
          // 新規入社
          const enter = ENTER
          // 再入社
          const again = AGAIN
          // 物件追加
          const add = ADD
          // 契約変更
          const retire1 = RETIRE1
          // 退職
          const retire2 = RETIRE2
          // その他変更
          const other = OTHER

          if (ec && ec.length) {
            const e = ec[0]
            if (e == '新規入社') {
              if (enter.includes(name)) {
                return true
              }
            } else if (e == '再入社') {
              if (again.includes(name)) {
                return true
              }
            } else if (e == '物件追加') {
              if (add.includes(name)) {
                return true
              }
            } else if (e == '契約変更') {
              if (retire1.includes(name)) {
                return true
              }
            } else if (e == '退職') {
              if (retire2.includes(name)) {
                return true
              }
            } else if (e == 'その他変更') {
              if (other.includes(name)) {
                return true
              }
            }
          }
          return false
        }
      },
    },

    watch: {
      loading(val) {
        if (val) {
          this.$emit('loadingStart')
        } else {
          this.$emit('loadingEnd')
        }
      }
    },

    created() {
      // 清掃員リスト取得
      this.getEmploymentNameList()
    },

    methods: {
      /**
       * 入力チェック
       */
      async validation() {
        // 種別
        const type = this.type

        if (!['新規入社', '再入社'].includes(type)) {
          if (!this.requestPost.employmentStaffNumber) {
            await dialogs.showErrorDialog('清掃員をドロップダウンから選択しなおしてください', '「社員番号」が取得できていません。ドロップダウンから清掃員を選択してください。')
            return false
          }

          const staffData = this.employmentNameList.find((e) => {
            return this.requestPost.employmentStaffNumber == e.staffDailyCleaning
          })
          if (staffData) {
            if (staffData.nameStaff != this.requestPost.employmentName) {
              await dialogs.showErrorDialog('清掃員をドロップダウンから選択しなおしてください', '「社員番号」と「氏名」が一致しません。データに矛盾が発生するため、清掃員をドロップダウンから選択後は氏名を変更しないようお願いいたします。')
              return false
            }
          }

          // 二重登録を防ぐ（ユーザー決定 2026-09-23）：新規登録のときだけ、同じ清掃員に AKBS登録前の雇い入れの申請（契約詳細入力画面から作ったものを含む）があれば
          // 新しく作らず、その申請画面へ移ってもらう（AKBS登録済み・削除以外の申請が対象。契約詳細入力画面の「既にタスクあり」と同じ決まり）
          if (!this.requestPost._id && !await this.checkOpenRequest()) {
            return false
          }
        }

        // 配列、文字列
        const items = [
          { key: 'employmentClass', name: '種別' }
          ,{ key: 'modifyType', name: '変更もしくは終了' }
          ,{ key: 'employmentHireDate', name: '入社日' }
          ,{ key: 'employmentRetirementDate', name: '退職日' }
          ,{ key: 'employmentName', name: '氏名' }
          ,{ key: 'employmentMaterial', name: '必要な書類' }
        ]

        for (let i = 0; i < items.length; i++) {
          const item = items[i]
          
          let res = {}
          // 配列
          if (Array.isArray(this.requestPost[item.key])) {
            res = this.requireValidateArr(item.key, item.name)

          // 文字列
          } else {
            res = this.requireValidateStr(item.key, item.name)
          }

          if (!res.result) {
            await dialogs.showInfoDialog('入力確認', res.message, 'OK')
            return false
          }
        }

        // オブジェクト
        const valObj = [
          { key: 'employmentDocument', name: '履歴書' }
        ]
        for (let i = 0; i < valObj.length; i++) {
          const a = valObj[i]
          let res = {}
          res = this.requireValidateAttach(a.key, a.name)
          if (!res.result) {
            await dialogs.showInfoDialog('入力確認', res.message, 'OK')
            return false
          }
        }

        return true
      },

      /**
       * 添付ファイル
       */
      attachmentChange(targetAttachmentName, attachmentInfo) {

        // 面接から履歴書を引き継いでいたので、変更の際はそれをリセット
        delete this.requestPost[targetAttachmentName + '_file_content']
        delete this.requestPost[targetAttachmentName + '_display_file_name']
        delete this.requestPost[targetAttachmentName + '_file_name']

        if (!this.requestPost[targetAttachmentName]) {
          this.requestPost[targetAttachmentName] = helper.createEmptyAttachment()
        }
        if (attachmentInfo) {
          this.requestPost[targetAttachmentName].originalName = attachmentInfo.filename
          this.requestPost[targetAttachmentName].content = attachmentInfo.content
        } else {
          this.requestPost[targetAttachmentName] = helper.createEmptyAttachment()
        }
      },

      /**
       * タイトルをセット
       */
      setTitle() {
        if (this.type != '新規入社') {
          this.$emit('get-title2', this.requestPost)
        }
      },

      /**
       * 清掃員リスト取得
       */
      async getEmploymentNameList() {
        this.employmentNameList = []
        // 新規入社の場合は取得不要
        if (this.type == '新規入社') {
          return
        }

        const list = await backend.searchData('akbsTable/getInstructEmploymentStaff', { type: this.type})
        if (list && list.data.data && list.data.data.length) {
          this.staffListType = ''
          if (this.type == '再入社') {
            this.staffListType = '退職者'
          }
          this.employmentNameList = list.data.data
        }
      },

      /**
       * 清掃員名選択
       */
      async staffSelected(e) {
        // v-model（change）は watch 経由で次の tick に反映されるため、selected の時点ではまだ前の氏名のまま。
        // setTitle で正しい氏名が入るよう、ここで先に入れておく
        this.requestPost.employmentName = e.nameStaff || ''

        if (this.type == '再入社') {
          this.requestPost.beforeStaffCd = e.staffDailyCleaning
          this.requestPost.employmentStaffNumber = ''

          // 前回の退職の内容（氏名の下に出す。再入社NGなら忠告も出す）
          this.requestPost.beforeDateResignation = e.dateResignation || ''
          this.requestPost.beforeRetireReason = e.retireReason || ''
          this.requestPost.beforeIsBanned = !!e.isBanned
        } else {
          this.requestPost.employmentStaffNumber = e.staffDailyCleaning
          this.clearBeforeRetire()
        }
        this.setTitle()
        this.reload++

        if (this.requestPost.beforeIsBanned) {
          await dialogs.showWarningDialog(
            '再入社NGの清掃員です',
            `${e.nameStaff} さんは、前回の退職時に「再入社NG」になっています。\n退職日：${this.formatDate(e.dateResignation) || '－'}\n退職理由：${e.retireReason || '－'}\n\n再入社させてよいか、確認のうえ進めてください。`
          )
        }
      },

      /**
       * 清掃員名変更
       */
      async staffChanged() {
        if (!this.requestPost.employmentName) {
          this.requestPost.employmentStaffNumber = ''
          this.clearBeforeRetire()
        }
        this.setTitle()
        this.reload++
      },

      /**
       * 前回の退職の内容を消す（再入社以外を選んだとき、氏名を消したとき）
       */
      clearBeforeRetire() {
        this.requestPost.beforeDateResignation = ''
        this.requestPost.beforeRetireReason = ''
        this.requestPost.beforeIsBanned = false
      },

      /**
       * 日付の表示（YYYY-MM-DD。AKBS からは日時の文字列で返ることがあるため揃える。無ければ空文字）
       * @param {*} value 日付
       */
      formatDate(value) {
        if (!value) {
          return ''
        }
        const m = moment(value)
        return m.isValid() ? m.format('YYYY-MM-DD') : String(value)
      },

      /**
       * 種別変更
       */
      async changeEmploymentClass() {
        // 再入社に変更、もしくは、再入社から違うものに変更
        if (this.type == '再入社' || (this.type != '再入社' && this.staffListType == '退職者')) {
          this.getEmploymentNameList()
        }
        this.setTitle()

        // メイン期限設定
        this.setLimitDate()
      },

      /**
       * 期限設定
       */
      setLimitDate() {
        if (this.type == '退職' && this.requestPost.employmentRetirementDate) {
          // 給料は翌月に生産されるため、退職日の翌月20日に設定
          this.requestPost.limitDate = moment(this.requestPost.employmentRetirementDate).add(1, 'months').format('YYYY-MM-20')
          // 期限日が1か月後なら長期タスク
          // this.requestPost.kubunLimit = utils.getKubunLimit(this.requestPost.limitDate)
          this.requestPost.kubunLimit = 2

        // 新規
        } else if (this.type == '新規入社' || this.type == '再入社') {
          if (this.requestPost.employmentHireDate > this.requestPost.startDateWork) {
            this.requestPost.startDateWork = ''
          }
          this.requestPost.kubunLimit = 2
        }
        this.reload++
      },

      /**
       * 退職届
       */
      /**
       * 契約変更の種別
       */
      clickModifyType(val, changeOnlyPrice) {
        if (this.referenceMode) {
          return
        }
        this.requestPost.modifyType = val
        this.requestPost.changeOnlyPrice = changeOnlyPrice
        this.setTitle()
        this.reload++
      },

      /**
       * 清掃員詳細画面
       */
      /**
       * 雇い入れ➡AKBS画面に遷移
       */
      toAkbsEmployment() {
        this.$router.push({
          name: 'AkbsInputForm',
          query: { requestPostId: this.requestPost._id, from: 'employment' },
          // 清掃員名・入社日
          params: { name: this.requestPost.employmentName, dateHire: this.requestPost.employmentHireDate, dateRetire: this.requestPost.employmentRetirementDate }
        })
      },

      /**
       * 同じ清掃員に AKBS登録前の雇い入れの申請が無いか（新規登録のとき）
       * あれば止めて、「申請画面を開く」でその申請画面（AkbsInputForm）へ移る（入力中の内容は登録しない）
       * API: akbsInputForm/getOpenRequest
       * @returns {Boolean} 無ければ true（登録してよい）
       */
      async checkOpenRequest() {
        let open = null
        try {
          const res = await backend.searchData('akbsInputForm/getOpenRequest', { staffCode: this.requestPost.employmentStaffNumber })
          open = res.data && res.data.data
        } catch (e) {
          console.log(e)
          await dialogs.showErrorDialog('確認エラー', 'この清掃員の申請があるかの確認に失敗しました。もう一度お試しください。')
          return false
        }
        if (!open) {
          return true
        }

        const no = open.requestNo ? `No.${open.requestNo}` : '問い合わせNo なし'
        const dialog = await dialogs.showConfirmDialog(
          'この清掃員の申請が既にあります',
          `${this.requestPost.employmentName} さんには、AKBS登録前の雇い入れの申請（${no}・${open.status}）があります。\n新しく雇い入れを作らず、その申請画面で内容を直してください。\n\n「申請画面を開く」を押すと、入力中の内容は登録せずにその申請画面へ移ります。`,
          '申請画面を開く',
          'キャンセル'
        )
        if (dialog === 'YES') {
          this.$router.push({ name: 'AkbsInputForm', query: { requestPostId: open.employmentId, from: 'employment' } })
        }
        return false
      }
    }
  }
</script>

<style scoped>
  .five-selection >>> button[type=button] {
    width: 19.8% !important;
  }

</style>